<!-- <app-tab-home></app-tab-home> -->
<app-nav-logo></app-nav-logo>

<div class="content">

    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-3 col-lg-3"></div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12
                text-center">
                <div class="row">
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-9" id="TypeCoop" [ngClass]="(TypeCoop == true)?'active':''"
                            (click)="select_TypeCoop($event.target.id)">ข้อมูลสหกรณ์</button>
                    </div> -->
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-5" id="TypeAgri" [ngClass]="(TypeAgri
                            ==
                            true)?'active':''" (click)="select_TypeAgri($event.target.id)">ข้อมูลกลุ่มเกษตรกร</button>
                    </div> -->
                </div>
            </div>
            <div class="col-xl-3 col-lg-3"></div>
        </div>
    </div>

    <ng-container *ngIf="TypeCoop">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-12">
                    <div class="content-tab">
                        <!-- Nav pills -->
                        <ul class="nav nav-pills" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="agri_page('Agri')">ข้อมูลทั่วไป</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="pill"
                                    (click)="agri_page('Agri-Insert')">ค้นหาข้อมูลราย เขต /
                                    ภาค</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill"
                                    (click)="agri_page('Agri-Assets')">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill"
                                    (click)="agri_page('Agri-Machine')">เครื่องจักรกลการเกษตร</a>
                            </li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tab-content">
                                    <div id="info" class="tab-pane fade">

                                    </div>
                                    <div id="resert" class="tab-pane  active">
                                        <div class="container">
                                            <div class="row mt-5">
                                                <div class="col-lg-12 text-center">
                                                    <h5>ค้นหาข้อมูลราย เขต / ภาค</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="container-fluid mb-3">
                                            <div class="row ">

                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                    <p class="text-left">เลือกภาค : </p>
                                                    <select class="form-control"
                                                        (change)="setphak($event.target.value)">
                                                        <option>- กรุณาเลือก -</option>
                                                        <option *ngFor="let items of PhakList" value="{{items.phakId}}">
                                                            {{items.phakName}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-auto pt-3">
                                                    <button class="btn btn-info float-left" (click)="searchPhak()">
                                                        <i class="fas fa-search"></i>
                                                    </button>
                                                </div>

                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                    <p class="text-left">เลือกเขต : </p>
                                                    <select class="form-control"
                                                        (change)="setkhet($event.target.value)">
                                                        <option>- กรุณาเลือก -</option>
                                                        <option *ngFor="let items of checkkhet"
                                                            value="{{items.khet_id}}">
                                                            {{items.khet_desc}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-auto pt-3">
                                                    <button class="btn btn-info float-left" (click)="searchKhet()">
                                                        <i class="fas fa-search"></i>
                                                    </button>
                                                </div>

                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                    <p class="text-left">เลือกจังหวัด : </p>
                                                    <select class="form-control"
                                                        (change)="setProvince($event.target.value)">
                                                        <option>- กรุณาเลือก -</option>
                                                        <option *ngFor="let items of ProvinceByKhet"
                                                            value="{{items.orgOrgId}}" id="{{items.provinceNameSort}}">
                                                            {{items.provinceNameSort}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 w-100 mt-auto pt-3">
                                                    <button class="btn btn-info float-left" (click)="searchProvince()">
                                                        <i class="fas fa-search"></i>
                                                    </button>
                                                </div>

                                                <div class="col-xl-2 col-sm-12"></div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                    <p class="text-left">ค้นหาชื่อกลุ่มเกษตรกร : </p>
                                                    <input type="text" [(ngModel)]="CoopNameTh" class="form-control">
                                                </div>
                                                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12 mt-auto pt-3">
                                                    <button class="btn btn-info float-left" (click)="SearchName()">
                                                        <i class="fas fa-search"></i></button>
                                                </div>
                                                <div class="col-xl-2 col-sm-12"></div>

                                            </div>

                                            <div class="col-lg-12 mt-4">
                                                <hr>
                                            </div>

                                            <ng-container *ngIf="selectPhak == true">
                                                <div class="row mt-5 mb-4">
                                                    <div class="col-lg-3 col-md-12 col-sm-12"></div>
                                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center tab">
                                                        <ul class="nav nav-tabs col-xl-12">
                                                            <li class="">
                                                                <a class="" id="Info" [ngClass]="(Info ==
                                                                    true)?'active' : ''"
                                                                    (click)="select_Info($event.target.id)">ภาพรวมจากการค้นหา</a>
                                                            </li>
                                                            <li class="">
                                                                <a class="" id="List" [ngClass]="(List ==
                                                                    true)?'active' : ''"
                                                                    (click)="select_List($event.target.id)">รายชื่อกลุ่มเกษตรกรจากการค้นหา</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="col-lg-3 col-md-12 col-sm-12"
                                                        style="text-align: right;">
                                                        <i class="fa fa-eye fa-2x" aria-hidden="true"
                                                            style="width: 25px; vertical-align: middle; padding-bottom: 2px; color: black;"></i>
                                                        จำนวนผู้เข้าชม : {{viewer}} ครั้ง
                                                    </div>
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col" style="text-align: right;">
                                                        ภาคการเกษตร
                                                        <select class="form-select mr-3" name="list_sector"
                                                            id="list_sector"
                                                            (change)="selectNewYearAndSector('',$event.target.value)"
                                                            [(ngModel)]="sector_now">
                                                            <option *ngFor="let x of listsector" value="{{x.value}}">
                                                                {{x.name}}</option>
                                                        </select>
                                                        ข้อมูล ณ ปี
                                                        <select class="form-select" name="list_year" id="list_year"
                                                            (change)="selectNewYearAndSector($event.target.value,'')"
                                                            [(ngModel)]="year_now">
                                                            <option *ngFor="let y of listYear" value="{{y}}">{{y}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <ng-container *ngIf="Info">
                                                    <div class="row">
                                                        <div class="col-12 text-center">
                                                            <h2><b>{{head_title}} {{show_title}}</b></h2>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <p class="text-black-50 m-0 p-0 text-right"
                                                                style="font-size: 1rem;">
                                                                ข้อมูล ณ ปี {{year_now}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนสมาชิกกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12">
                                                                            <h6 class="text-center p-2 mt-3">ข้อมูล ณ
                                                                                วันที่
                                                                                {{Date_after_day}} {{Month_now_}}
                                                                                {{year_now_}}
                                                                            </h6>
                                                                        </div>
                                                                        <div
                                                                            class="col-xl-12 col-md-12 col-sm-12 d-flex">
                                                                            <div class="col-xl-4 col-lg-4 col-md-4">
                                                                                <img src="/assets/images/vegetables.png"
                                                                                    class="w-100" alt="">
                                                                            </div>
                                                                            <div
                                                                                class="col-xl-8 col-lg-8 col-lg-8 text-center p-0">
                                                                                <!-- <span>สหกรณ์</span> -->
                                                                                <p class="content-user mt-auto mb-auto">
                                                                                    {{CoopOracleCount |
                                                                                    number:'':'he'}} แห่ง
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div id="chartdiv_AN_insert"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนสมาชิกกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/farmer-m.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{MemberDataM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/farmer-fm.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{MemberDataFm
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>สมาชิกรวม</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{MemberSum |
                                                                                number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนกรรมการ
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-4">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/employee1.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CommitteeSumM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/employee.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CommitteeSumFm
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>กรรมการ</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{CommitteeSum | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        จำนวนเจ้าหน้าที่กลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/steward.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CoopOfficerYearMemberM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/stewardess.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CoopOfficerYearMemberFm
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>พนักงาน</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{CoopOfficerYearMember |
                                                                                number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-12 col-sm-12 mt-4">
                                                            <div class="card
                                                            h-100">
                                                                <div class="card-header">
                                                                    <div class="col-lg-12
                                                                    col-md-12">
                                                                        <h6 class="font-weight-bold">มาตรฐานกลุ่มเกษตรกร
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Standard_insert">
                                                                    </div>
                                                                    <!-- <div class="col-xl-12
                                                                    text-right">
                                                                        <p>ที่มา : กรมส่งเสริมกลุ่มเกษตรกร
                                                                        </p>
                                                                    </div> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-xl-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header">
                                                                    <div class="col-lg-12 col-md-12">
                                                                        <h6 class="font-weight-bold">
                                                                            ระดับขั้นความเข้มแข็ง</h6>
                                                                    </div>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Strong_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 text-right">
                                                                        <p>ที่มา : กรมส่งเสริมสหกรณ์
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนกลุ่มเกษตรกร
                                                                        ทุกประเภท
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="col-xl-12">
                                                                        <div class="table-responsive">
                                                                            <table class="table table-bordered m-0">
                                                                                <thead class="thead-light">
                                                                                    <tr>
                                                                                        <th colspan="2"
                                                                                            class="text-center">
                                                                                            สถานะ</th>
                                                                                        <th colspan="2"
                                                                                            class="text-center">
                                                                                            มาตรฐาน</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th
                                                                                            class="text-center table-success">
                                                                                            Active</th>
                                                                                        <th
                                                                                            class="text-center table-danger">
                                                                                            Non-active</th>
                                                                                        <th
                                                                                            class="text-center table-success">
                                                                                            ผ่าน</th>
                                                                                        <th
                                                                                            class="text-center table-danger">
                                                                                            ไม่ผ่าน</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>{{Active_coopType1 |
                                                                                            number: '':'he'}}</td>
                                                                                        <td>{{InActive_coopType1 |
                                                                                            number: '':'he'}}</td>
                                                                                        <td>{{StandardTypeSum_pass |
                                                                                            number: '':'he'}}</td>
                                                                                        <td>
                                                                                            {{StandardTypeSum_notPass |
                                                                                            number:
                                                                                            '':'he'}}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                            <!-- <table class="table table-bordered">
                                                                                <thead class="thead-light">
                                                                                    <tr>
                                                                                        <th colspan="4" class="text-center">
                                                                                            ระดับขั้นความเข้มแข็ง</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 1</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 2</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 3</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 4</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>{{TypeLevelSum1 | number:'':'he'}}
                                                                                        </td>
                                                                                        <td>{{TypeLevelSum2 | number:'':'he'}}
                                                                                        </td>
                                                                                        <td>{{TypeLevelSum3 | number:'':'he'}}
                                                                                        </td>
                                                                                        <td>{{TypeLevelSum4 | number:'':'he'}}
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4"
                                                            *ngFor="let items of CoopOracleTypes ; let i = index;">
                                                            <div class="card h-100"
                                                                *ngIf="items.coopType == '1' || items.coopType == '2' || items.coopType == '3' || items.coopType == '4' || items.coopType == '5' || items.coopType == '6' || items.coopType == '7'">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '1'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา
                                                                    </h6>
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '2'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่
                                                                    </h6>
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '3'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน
                                                                    </h6>
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '4'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง
                                                                    </h6>
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '5'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                                                    </h6>
                                                                    <h6 class="font-weight-bold"
                                                                        *ngIf="items.coopType == '6'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ
                                                                    </h6>
                                                                    <!-- <h6 class="font-weight-bold" *ngIf="items.coopType == '7'">
                                                                        จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเครดิตยูเนี่ยน
                                                                    </h6> -->
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="col-xl-12">
                                                                        <div class="table-responsive">
                                                                            <table class="table table-bordered m-0">
                                                                                <thead class="thead-light">
                                                                                    <tr>
                                                                                        <th colspan="2"
                                                                                            class="text-center">
                                                                                            สถานะ</th>
                                                                                        <th colspan="2"
                                                                                            class="text-center">
                                                                                            มาตรฐาน</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th
                                                                                            class="text-center table-success">
                                                                                            Active</th>
                                                                                        <th
                                                                                            class="text-center table-danger">
                                                                                            Non-active</th>
                                                                                        <th
                                                                                            class="text-center table-success">
                                                                                            ผ่าน</th>
                                                                                        <th
                                                                                            class="text-center table-danger">
                                                                                            ไม่ผ่าน</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>{{items.active |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td>{{items.nonActive |
                                                                                            number:'':'he'}}
                                                                                        </td>

                                                                                        <td
                                                                                            *ngIf="items.coopType == '1'">
                                                                                            {{StandardType_pass_level1 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '1'">
                                                                                            {{StandardType_notPass_level1
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '2'">
                                                                                            {{StandardType_pass_level2 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '2'">
                                                                                            {{StandardType_notPass_level2
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '3'">
                                                                                            {{StandardType_pass_level3 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '3'">
                                                                                            {{StandardType_notPass_level3
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '4'">
                                                                                            {{StandardType_pass_level4 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '4'">
                                                                                            {{StandardType_notPass_level4
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '5'">
                                                                                            {{StandardType_pass_level5 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '5'">
                                                                                            {{StandardType_notPass_level5
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '6'">
                                                                                            {{StandardType_pass_level6 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td
                                                                                            *ngIf="items.coopType == '6'">
                                                                                            {{StandardType_notPass_level6
                                                                                            |
                                                                                            number:'':'he'}}</td>
                                                                                        <!-- <td *ngIf="items.coopType == '7'">
                                                                                            {{StandardType_pass_level7 |
                                                                                            number:'':'he'}}</td>
                                                                                        <td *ngIf="items.coopType == '7'">
                                                                                            {{StandardType_notPass_level7 |
                                                                                            number:'':'he'}}</td> -->

                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                            <!-- <table class="table table-bordered">
                                                                                <thead class="thead-light">
                                                                                    <tr>
                                                                                        <th colspan="4" class="text-center">
                                                                                            ระดับขั้นความเข้มแข็ง</th>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 1</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 2</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 3</th>
                                                                                        <th class="text-center">
                                                                                            ชั้นที่ 4</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td *ngIf="items.coopType == '1' ">
                                                                                            {{TypeLevel1_type1 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '2' ">
                                                                                            {{TypeLevel1_type2 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '3' ">
                                                                                            {{TypeLevel1_type3 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '4' ">
                                                                                            {{TypeLevel1_type4 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '5' ">
                                                                                            {{TypeLevel1_type5 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '6' ">
                                                                                            {{TypeLevel1_type6 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '7' ">
                                                                                            {{TypeLevel1_type7 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '1' ">
                                                                                            {{TypeLevel2_type1 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '2' ">
                                                                                            {{TypeLevel2_type2 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '3' ">
                                                                                            {{TypeLevel2_type3 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '4' ">
                                                                                            {{TypeLevel2_type4 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '5' ">
                                                                                            {{TypeLevel2_type5 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '6' ">
                                                                                            {{TypeLevel2_type6 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '7' ">
                                                                                            {{TypeLevel2_type7 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '1' ">
                                                                                            {{TypeLevel3_type1 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '2' ">
                                                                                            {{TypeLevel3_type2 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '3' ">
                                                                                            {{TypeLevel3_type3 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '4' ">
                                                                                            {{TypeLevel3_type4 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '5' ">
                                                                                            {{TypeLevel3_type5 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '6' ">
                                                                                            {{TypeLevel3_type6 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '7' ">
                                                                                            {{TypeLevel3_type7 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '1' ">
                                                                                            {{TypeLevel4_type1 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '2' ">
                                                                                            {{TypeLevel4_type2 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '3' ">
                                                                                            {{TypeLevel4_type3 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '4' ">
                                                                                            {{TypeLevel4_type4 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '5' ">
                                                                                            {{TypeLevel4_type5 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '6' ">
                                                                                            {{TypeLevel4_type6 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                        <td *ngIf="items.coopType == '7' ">
                                                                                            {{TypeLevel4_type7 |
                                                                                            number:'':'he'}}
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        สินทรัพย์ของกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12 p-0">
                                                                        <div id="chartdiv_asset_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#asset1insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">หนี้สินของกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12 p-0">
                                                                        <div id="chartdiv_debt_insert">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#asset2insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ทุนของกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12 p-0">
                                                                        <div id="chartdiv_Capital_insert">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#asset3insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        กำไร(ขาดทุน)ของกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12 p-0">
                                                                        <div id="chartdiv_profit_insert">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#asset4insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        รวมทุกประเภทกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#myModal_insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรทำนา
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type1_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type1insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรทำไร่
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type2_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type2insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรทำสวน
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type3_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type3insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรประมง
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type4_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type4insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type5_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type5insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                        ประเภทกลุ่มเกษตรกรอื่นๆ
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-0">
                                                                    <div class="col-xl-12">
                                                                        <div id="chartdiv_business_type6_insert"></div>
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Type6insert">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์ กลุ่มเกษตรกร
                                                                        ทุกประเภท
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_coop_sum_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participationinsert"
                                                                            (click)="Participationinsert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรทำนา
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_coop_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation1insert"
                                                                            (click)="Participation1insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรทำไร่
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_fishing_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation2insert"
                                                                            (click)="Participation2insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรทำสวน
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_Settlement_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation3insert"
                                                                            (click)="Participation3insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรประมง
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_saving_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation4insert"
                                                                            (click)="Participation4insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรเลี้ยงสัตว์
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_shop_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation5insert"
                                                                            (click)="Participation5insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">
                                                                        การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                        กลุ่มเกษตรกรอื่นๆ
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div id="chartdiv_Participation_service_insert">
                                                                    </div>
                                                                    <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                        <a href="" data-toggle="modal"
                                                                            data-target="#Participation6insert"
                                                                            (click)="Participation6insert()">ดูเพิ่มเติม</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </ng-container>

                                                <ng-container *ngIf="List">
                                                    <!-- <div class="row"> -->
                                                    <div class="col-12 text-center">
                                                        <h2><b>{{head_title}} {{show_title}}</b></h2>
                                                    </div>
                                                    <!-- </div> -->
                                                    <div class="col-lg-12 p-0">
                                                        <div class="row">
                                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12
                                                                mt-3 p-0" *ngIf="CoopStatusProvinceYearBySearch != '' &&
                                                                CoopStatusProvinceYearBySearch
                                                                != undefined">
                                                                <p class="text-right mb-1">จำนวนผลลัพธ์การค้นหา :
                                                                    {{sumResult}}
                                                                </p>
                                                                <div class="card">
                                                                    <div class="card-header p-2">
                                                                        <div class="row">
                                                                            <div class="col-lg-8 col-md-12
                                                                                col-sm-12">
                                                                                <p class="m-0">รายชื่อจังหวัด</p>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-12
                                                                                col-sm-12">
                                                                                <h6 class="text-black-50 text-right"
                                                                                    *ngIf="datayear
                                                                                    !=
                                                                                    undefined">ข้อมูล ณ ปี {{ year_now
                                                                                    }}
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="card-body">
                                                                        <div class="table-responsive">
                                                                            <table class="table table-hover">
                                                                                <thead>
                                                                                    <tr class="table-active">
                                                                                        <th scope="col">จังหวัด</th>
                                                                                        <th scope="col">Active</th>
                                                                                        <th scope="col">Non - Active
                                                                                        </th>
                                                                                        <th scope="col">รวม</th>
                                                                                        <th scope="col" width="15%">
                                                                                            รายชื่อกลุ่มเกษตรในจังหวัด
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody *ngFor="let items of
                                                                                    pageOfItems;
                                                                                    let i = index">
                                                                                    <tr>
                                                                                        <th scope="row">
                                                                                            {{items.provinceName}}</th>
                                                                                        <td>{{items.active}}</td>
                                                                                        <td>{{items.nonActive}}</td>
                                                                                        <td>{{items.sum}}</td>
                                                                                        <td class="text-center">
                                                                                            <button class="btn btn-info"
                                                                                                value="{{items.orgOrgId}}"
                                                                                                (click)="selectProvice_Search(i)">
                                                                                                <i
                                                                                                    class="fas fa-search"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                    <div class="card-footer">
                                                                        <jw-pagination
                                                                            [items]="CoopStatusProvinceYearBySearch"
                                                                            (changePage)="onChangePage($event)">
                                                                        </jw-pagination>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12
                                                                mt-5 p-0" *ngIf="selectProviceSearch == true">
                                                                <p class="text-right mt-5 mb-1">จำนวนผลลัพธ์การค้นหา :
                                                                    {{sumResult_}}
                                                                </p>
                                                                <div class="card">
                                                                    <div class="card-header p-2">
                                                                        <div class="row">
                                                                            <div class="col-lg-8 col-md-12
                                                                                col-sm-12">
                                                                                <p class="m-0">รายชื่อกลุ่มเกษตรกร</p>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-12
                                                                                col-sm-12">
                                                                                <h6 class="text-black-50 text-right"
                                                                                    *ngIf="datayear
                                                                                    !=
                                                                                    undefined">ข้อมูล ณ ปี {{ year_now
                                                                                    }}
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="card-body">
                                                                        <div class="form-group row d-none">
                                                                            <div class="col-xl-12 col-lg-12 col-md-12
                                                                                col-sm-12
                                                                                mb-3">
                                                                                <div class="col-xl-4 col-lg-4 col-md-12
                                                                                    col-sm-12">
                                                                                    <label for="inputPassword"
                                                                                        class="col-form-label">ค้นหารายการ</label>
                                                                                </div>
                                                                                <div class="col-xl-8 col-lg-8 col-md-12
                                                                                    col-sm-12">
                                                                                    <input class="form-control w-100"
                                                                                        type="text" name="search"
                                                                                        [(ngModel)]="searchText">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="table-responsive">
                                                                            <table class="table table-hover">
                                                                                <thead>

                                                                                    <tr class="table-active">
                                                                                        <th width="30%">ชื่อกลุ่มเกษตรกร
                                                                                        </th>
                                                                                        <th scope="col">รหัสกลุ่มเกษตรกร
                                                                                        </th>
                                                                                        <th scope="col">
                                                                                            มาตรฐานกลุ่มเกษตรกร
                                                                                        </th>
                                                                                        <th scope="col"
                                                                                            style="text-align: center;">
                                                                                            สมาชิกกลุ่มเกษตรกร
                                                                                            ทั้งหมด
                                                                                        </th>
                                                                                        <th scope="col"
                                                                                            style="text-align: center;">
                                                                                            เพิ่มเติม</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr
                                                                                        *ngFor="let items of
                                                                                        pageOfItemslistCoop |
                                                                                        filter:searchText; let i = index">
                                                                                        <th scope="row">
                                                                                            {{items.agriNameTh}}</th>
                                                                                        <td>{{items.registryNo2}}</td>
                                                                                        <td *ngIf="items.agriStandard
                                                                                            == '1'">
                                                                                            ผ่านมาตรฐานกลุ่มเกษตรกร
                                                                                        </td>
                                                                                        <td *ngIf="items.agriStandard
                                                                                            == '2'">
                                                                                            ไม่ผ่านมาตรฐานกลุ่มเกษตรกร
                                                                                        </td>
                                                                                        <td *ngIf="items.agriStandard
                                                                                            == '3'">
                                                                                            ไม่นำมาจัดมาตรฐานกลุ่มเกษตรกร
                                                                                        </td>
                                                                                        <td class="text-center">
                                                                                            {{items.member}}</td>
                                                                                        <td>
                                                                                            <button class="btn btn-info
                                                                                                w-100"
                                                                                                (click)="selectCoopProfile(i,2)"
                                                                                                id="{{items.agriId}}"
                                                                                                value="{{items.agriId}}">
                                                                                                <i class="fas
                                                                                                    fa-search"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                    </div>
                                                                    <div class="card-footer">
                                                                        <jw-pagination [items]="listCoop"
                                                                            (changePage)="onChangePagelistCoop($event)">
                                                                        </jw-pagination>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </ng-container>

                                            </ng-container>

                                            <ng-container *ngIf="searchName_  == true">
                                                <div class="row">
                                                    <div class="col-xl-12">
                                                        <p class="text-right mt-5 mb-1">จำนวนผลลัพธ์การค้นหา :
                                                            {{sumResult}}</p>
                                                        <div class="table-responsive">
                                                            <table class="table table-hover">
                                                                <thead class="thead-light">
                                                                    <tr>
                                                                        <th>
                                                                            ชื่อกลุ่มเกษตรกร</th>
                                                                        <th>
                                                                            จำนวนสมาชิกเพศชาย (คน)</th>
                                                                        <th>
                                                                            จำนวนสมาชิกเพศหญิง (คน)</th>
                                                                        <th>
                                                                            จำนวนสมาชิกทั้งหมด (คน)</th>
                                                                        <th>ดูเพิ่มเติม</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="text-left">
                                                                    <tr
                                                                        *ngFor="let items of CoopProfileAll; let i = index">
                                                                        <td>{{items.coopNameTh}}</td>
                                                                        <td>{{items.memberFm || '-'}}</td>
                                                                        <td>{{items.memberM || '-'}}</td>
                                                                        <td>{{items.member || '-'}}</td>
                                                                        <td>
                                                                            <button class="btn btn-info w-100"
                                                                                (click)="selectCoopProfile(i,1)"
                                                                                id="{{items.coopId}}"
                                                                                value="{{items.coopId}}">
                                                                                <i class="fas
                                                                                fa-search"></i>

                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>

                                        </div>
                                    </div>
                                    <div id="asset_" class="tab-pane fade">
                                        <app-coop-assets></app-coop-assets>
                                    </div>
                                    <div id="machine_" class="tab-pane fade">
                                        <app-coop-machine></app-coop-machine>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <app-footer></app-footer> -->
        </div>
    </ng-container>

    <app-footer></app-footer>
</div>

<div class="container">
    <div id="myModal_insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_deposit_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_lend_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_products_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_produce_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_Processing_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_service_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type1insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body
                            p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                        pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type1_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type2insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                            pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body
                            p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header
                        pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type2_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type3insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type3_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type4insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type4_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type5insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type5_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Type6insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ
                                        ประเภทจัดหาสินค้ามาจำหน่าย

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวมผลผลิต</h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_type6_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset1insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">สินทรัพย์ของกลุ่มเกษตรกร
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำนา
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type1_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำไร่
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type2_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำสวน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type3_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type4_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรเลี้ยงสัตว์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type5_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรอื่นๆ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_asset_type6_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset2insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">หนี้สินของกลุ่มเกษตรกร
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำนา
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type1_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำไร่
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type2_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำสวน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type3_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type4_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรเลี้ยงสัตว์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type5_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรอื่นๆ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_debt_type6_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset3insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">ทุนของกลุ่มเกษตรกร
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำนา
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type1_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำไร่
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type2_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำสวน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type3_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type4_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรเลี้ยงสัตว์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type5_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรอื่นๆ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_Capital_type6_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="asset4insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">กำไร (ขาดทุน) ของกลุ่มเกษตรกร
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 mt-4">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำนา
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type1_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำไร่
                                            </h6>
                                        </div>
                                        <div class="card-body  p-0">
                                            <div id="chartdiv_profit_type2_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรทำสวน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type3_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรประมง
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type4_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรเลี้ยงสัตว์
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type5_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">
                                                กลุ่มเกษตรกรอื่นๆ
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div id="chartdiv_profit_type6_insert">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participationinsert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ทุกประเภท
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation1insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทสกลุ่มเกษตรกรทำนา
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type1_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation2insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type2_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation3insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type3_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation4insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type4_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation5insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทสหกรณ์ร้านค้า
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type5_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div id="Participation6insert" class="modal fade" role="dialog">
        <div class="modal-dialog col-12">
            <!-- Modal content-->
            <div class="modal-content col-12">
                <div class="modal-header">
                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทกลุ่มเกษตรกรอื่นๆ
                    </h6>
                    <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_deposit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_credit_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_sale_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_collect_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                        ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_transfrom_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_service_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทอื่น ๆ

                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_Participation_type6_other_val_insert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
